import React from 'react';

export interface TableProps extends React.HTMLAttributes<HTMLTableElement> {
  children: React.ReactNode;
  className?: string;
}

const Table = ({ children, className = '', ...props }: TableProps) => (
  <table className={className} {...props}>
    {children}
  </table>
);

export default Table;
